module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('data-table', {
    attrs: {
      "title": "Sharers",
      "table-ref": "telcotable",
      "icon": "fa fa-users",
      "url": '/licensees/site/' + _vm.siteData.id + (this.telcoId ? '/licensee/' + this.telcoId : ''),
      "fields": _vm.fields,
      "options": _vm.siteData,
      "add-props": _vm.noAdd ? null : _vm.addPropsData,
      "add-action": _vm.noAdd ? null : _vm.action,
      "showSearch": false,
      "detail-component": "lic-detail-row"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ddad5c6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sites/SiteSharers.vue
// module id = 1475
// module chunks = 0